











































































































import { Vue, Component, Mixins } from "vue-property-decorator";
import MyList from "@/mixins/list";
import Add from "./add.vue";
import Edit from "./edit.vue";

@Component({
  components: {
    Add,
    Edit
  }
})
export default class extends Mixins(MyList) {
  dispatchType = "stadium/settlementItems";

  dispatchTypeDelete = "setting/delete";

  deleteConfirmContent = "确认要删除该配置吗？";

  columns: any[] = [
    { title: "编号", dataIndex: "id" },
    { title: "分类", scopedSlots: { customRender: "type" } },
    { title: "名称", dataIndex: "name" },
    { title: "扣除", scopedSlots: { customRender: "value" } },
    { title: "返还", scopedSlots: { customRender: "value1" } },
    // { title: '属性', scopedSlots: { customRender: 'itype' } },
    { title: "操作", scopedSlots: { customRender: "action" } }
  ];

  async loadData1() {
    this.loading = true;
    const res = await this.$store.dispatch(this.dispatchType, {});
    if (res && res.Data) {
      this.data = res.Data;
    }
    this.loading = false;
  }

  hideAddModal1() {
    this.addModalVisible = false;
    this.loadData1();
  }

  hideEditModal1() {
    this.editModalVisible = false;
    this.loadData1();
  }

  handleDelete1(id: number) {
    this.$confirm({
      title: this.deleteConfirmTitle,
      content: this.deleteConfirmContent,
      onOk: async () => {
        const res = await this.$store.dispatch(this.dispatchTypeDelete, {
          id
        });
        if (res && res.Message === "success") {
          this.$message.success(res.Message);
          this.loadData1();
        } else {
          this.$message.error(res.Message);
        }
      },
      onCancel() {
        // alert('cancel')
      }
    });
  }

  mounted() {
    this.loadData1();
  }
}
